import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "google-drawing",
  "use": "google-drawing-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"google-drawing\"><g clip-path=\"url(#google-drawing_clip0_2_58)\"><rect width=\"16\" height=\"16\" rx=\"2\" fill=\"#D7322D\" /><path d=\"M8.095 8A3.25 3.25 0 108 8.095V13.5h5.5V8H8.095z\" fill=\"#fff\" /></g><defs><clipPath id=\"google-drawing_clip0_2_58\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol